/**
 *
 * @module geo/services
 */
import { FeatureCollection } from "geojson";
import watch from "redux-watch";
import { Observable } from "rxjs/Observable";
import {fromPromise} from 'rxjs/observable/fromPromise';
import { serviceExecuteSearchCreatorP } from "../actions/creators/services.creator";
import { SearchExecutionParameters } from "../functionalities/search";
import { SERVICE_EXECUTE_SEARCH } from "../payload/facade/services/SERVICE_EXECUTE_SEARCH";
import { ExecuteSearch } from "../types/services/execute.search";
import { GeoEvent } from "../types";
import { uuid } from "../utils/uuid";
import { FunctionalityOptions } from "../types/functionality";
import { Store } from "redux";
import { Service } from "./index";
import { Watcher } from "../watcher";
import { Watch } from "../decorators/watch";
import { stateOfFunctionality, stateOfSearchsService } from "../store/selectors";
import { AppStore } from "../store/app";
import { IHashServicesOperations } from "../types/services";


export class SearchService extends Service {
  protected defaultService: string = "acfSearchService";
   
  

 

  public executeSearch(  searches: FunctionalityOptions | FunctionalityOptions[],
       params?: SearchExecutionParameters,
       transient?:boolean,   idService?: string):Observable<ExecuteSearch>{

      let _searches: FunctionalityOptions[] ;
      if (!Array.isArray(searches)) {
         _searches = [searches];
      } else {
         _searches = searches;
      }
      const _params: SearchExecutionParameters = params ? params : {};
      let _id:string='';
      if (!idService) {
        _id = uuid();
      } else {
        _id = idService;
      }
      const _eventSource: string =  "geoapi2-js-internal";
      if(transient==undefined){
        transient=false;
      }
      const opt = new SERVICE_EXECUTE_SEARCH({
        transient:transient,
        id:_id,
        parameters: {
          searches:_searches,
          params:_params,
          id:_id,
          eventSource:_eventSource
        }
      });
    
      return fromPromise(serviceExecuteSearchCreatorP(opt, this.store.dispatch));

  }

  /**
   * execute searches without add to app.
   *
   * Example :
   *
   * ```
   * var service = top.geoApp.getService('SearchService');
   * var searches = geoApp.getResourcesByName("Recherche par défaut commune");
   * service.executeSearch([searches[0]],{"queryLimit":10,"filters":[{"attribute":"code_dept",values:["13",16]}]})
   *  .subscribe(
   *      (values)=>{console.log('searchResult',values)}
   *    );
   * ```
   *
   * @since 2.1.0
   */
  /** 
  public executeSearch(
    searches: FunctionalityOptions | FunctionalityOptions[],
    params?: SearchExecutionParameters,
    id?: string,
    eventSource?: string
  ): Observable<any> {
    let _searches: any = [];
    if (!Array.isArray(searches)) {
      _searches = [searches];
    } else {
      _searches = searches;
    }

    const _params: any = params ? params : {};
    let _id: string;
    if (!id) {
      _id = "__geoapi2-executeSearches__";
    } else {
      _id = id;
    }

    const _eventSource: string = eventSource ? eventSource : "geoapi2-js";

    const opt = new SERVICE_EXECUTE_SEARCH({
      params: {
        searches: _searches,
        params: _params,
        id: _id,
        eventSource: _eventSource
      }
    });
    return this.sendService<SERVICE_EXECUTE_SEARCH, ExecuteSearch>(
      serviceExecuteSearchCreatorP,
      opt
    )
      .pluck("result", "result")
      .mergeMap(
        () => {
          return new Observable((observer: any) => {
            const w = watch(this.store.getState, "events");
            this.store.subscribe(
              w((newVal: GeoEvent) => {
                if (newVal.eventName === "acfSearchExecuted") {
                  if (_id === newVal.args.id) {
                    observer.next(newVal.args.results as FeatureCollection);
                    observer.complete();
                  }
                }
              })
            );
          });
        },
        (_: unknown, res: FeatureCollection) => res
      );
  }
  */
}
